import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=446c5cee&scoped=true&"
import script from "./FaqPage.vue?vue&type=script&lang=js&"
export * from "./FaqPage.vue?vue&type=script&lang=js&"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=446c5cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c5cee",
  null
  
)

export default component.exports